// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-order-modal__body[data-v-4f2bd9c6]{min-height:300px}.history-order-modal__order-items[data-v-4f2bd9c6]{flex-grow:1}.history-order-modal__order-num[data-v-4f2bd9c6]{height:36px;width:23px;margin-bottom:11px}.history-order-modal__order-item[data-v-4f2bd9c6]{padding:6px 14px;background:#f1f1f4;border-radius:5px;margin-bottom:11px;max-width:275px;cursor:grab!important}", ""]);
// Exports
module.exports = exports;
